/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRarIcon16Light = forwardRef('GovKoRarIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.992 3.743C5.988 3.813 4.302 1.995 4.52 0c1.995.011 3.608 1.759 3.472 3.743Z" }),
        React.createElement("path", { d: "M3.873 7.967a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z" }),
        React.createElement("path", { d: "M9.375 6.592a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0Z" }),
        React.createElement("path", { d: "M9.375 13.708a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0Z" }),
        React.createElement("path", { d: "M13.502 6.592a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0Z" }),
        React.createElement("path", { d: "M5.936 11.525a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z" }),
        React.createElement("path", { d: "M11.438 10.15a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0Z" })));
});
